import isBlank from "../utils/isBlank";
import { PERMISSION } from "../utils/useGetUserHasPermission";
import * as ROUTES from "./routeConstants";

export function getIdCredentialDesignerUrl(token) {
  const parts = window.location.hostname.split(".");
  // Hostname pattern: [tenant].[env].x.fusesport.com — env is "dev" or "prd"
  // Falls back to "dev" for localhost or unrecognised patterns.
  const env = parts.includes("prd") ? "prd" : "dev";
  return `https://id.${env}.x.fusesport.com?token=${token}`;
}

const GLOBAL_NAV_MENU_ELEVATED = [
  {
    title: "Events",
    icon: "calendar",
    path: ROUTES.COMPETITION_MANAGEMENT,
    permission: PERMISSION.ACCESS_COMPETITION_MANAGEMENT,
  },
  {
    title: "Registrations",
    icon: "picture",
    path: ROUTES.REGISTRATIONS,
    usePath: false,
    permission: { or: [PERMISSION.ACCESS_FORMS, PERMISSION.ACCESS_REGISTRATIONS] },
    submenu: [
      {
        title: "Registrations",
        path: ROUTES.REGISTRATIONS,
        permission: PERMISSION.ACCESS_REGISTRATIONS,
      },
      {
        title: "Forms",
        path: ROUTES.FORMS,
        permission: PERMISSION.ACCESS_FORMS,
      },
    ],
  },
  {
    title: "People",
    icon: "user",
    path: "/people",
    disabled: false,
    permission: PERMISSION.ACCESS_PEOPLE,
  },
  {
    title: "Reports",
    icon: "file-text",
    path: "/reports",
    usePath: false,
    permission: { or: [PERMISSION.ACCESS_SUMMARY_REPORT] },
    submenu: [
      {
        title: "Summary Report",
        path: ROUTES.SUMMARY_REPORT,
        permission: PERMISSION.ACCESS_SUMMARY_REPORT,
      },      
      {
        title: "Financial",
        path: "/financial",
        usePath: false,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
        submenu: [
          {
            title: "Product Summary Report",
            key: "Product Summary Report",
            path: ROUTES.PRODUCT_SUMMARY_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Product Detail Report",
            key: "Product Detail Report",
            path: ROUTES.PRODUCT_DETAIL_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Product Refund Report",
            key: "Product Refund Report",
            path: ROUTES.PRODUCT_REFUND_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Credit Card Transaction Report",
            key: "Credit Card Transaction Report",
            path: ROUTES.CREDIT_CARD_TRANSACTION_SUMMARY_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Reg Transaction Report",
            key: "Reg Transaction Report",
            path: ROUTES.REG_TRANSACTION_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
        ],
      },
      {
        title: "Competitions",
        path: "/competitions",
        usePath: false,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
        submenu: [
          {
            title: "Individual Competition Summary Report",
            key: "Individual Competition Summary Report",
            path: ROUTES.INDIVIDUAL_COMPETITION_SUMMARY_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Individual Competition Detail Report",
            key: "Individual Competition Detail Report",
            path: ROUTES.INDIVIDUAL_COMPETITION_DETAIL_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Team Summary Report",
            key: "Team Summary Report",
            path: ROUTES.TEAM_SUMMARY_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Team Detail Report",
            key: "Team Detail Report",
            path: ROUTES.TEAM_DETAIL_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Team Manager Report",
            key: "Team Manager Report",
            path: ROUTES.TEAM_MANAGER_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Teamless Competitors Report",
            key: "Teamless Competitors Report",
            path: ROUTES.TEAMLESS_COMPETITORS_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Competitors with Other Competitions Report",
            key: "Competitors with Other Competitions Report",
            path: ROUTES.COMPETITORS_WITH_OTHER_COMPETITIONS_REPORT,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
        ],
      },
      {
        title: "Discount Codes",
        path: "/discounts",
        usePath: false,
        permission: PERMISSION.ACCESS_DISCOUNT_REPORTS,
        submenu: [
          {
            title: "Discount Code Usage Report",
            path: ROUTES.DISCOUNT_CODE_USAGE_REPORT,
            permission: PERMISSION.ACCESS_DISCOUNT_REPORTS,
          },
          {
            title: "Discount Code Transaction Report",
            path: ROUTES.DISCOUNT_CODE_TRANSACTION_REPORT,
            permission: PERMISSION.ACCESS_DISCOUNT_REPORTS,
          },
        ],
      },
    ],
  },
  {
    title: "Admin",
    icon: "setting",
    path: "/admin",
    permission: PERMISSION.TENANT_ADMIN_MENUS,
    usePath: false,
    submenu: [
      {
        title: "Roles",
        path: ROUTES.ROLES,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Group Types",
        path: ROUTES.GROUP_TYPES,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Groups",
        path: ROUTES.GROUPS,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Result Statuses",
        path: ROUTES.RESULT_STATUSES,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Sports",
        path: ROUTES.SPORTS,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Formats",
        path: ROUTES.FORMATS,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Score Types",
        path: ROUTES.SCORE_TYPES,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Custom Fields",
        path: ROUTES.FIELDS,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Countries",
        path: ROUTES.COUNTRIES,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Countries",
        path: ROUTES.COUNTRIES,
      },
      {
        title: "Discount Codes",
        path: ROUTES.DISCOUNT_CODES,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "Permission Management",
        path: ROUTES.USER_GROUP_ROLE_PERMISSIONS,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
      },
      {
        title: "System Settings",
        icon: "setting",
        path: "/settings",
        usePath: false,
        permission: PERMISSION.TENANT_ADMIN_MENUS,
        submenu: [
          {
            title: "Theme",
            path: ROUTES.SYSTEM_THEME,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
          {
            title: "Communications / Templates",
            path: ROUTES.SYSTEM_COMMUNICATIONS,
            permission: PERMISSION.TENANT_ADMIN_MENUS,
          },
        ],
      },
      {
        title: "ID Credential Designer",
        icon: "idcard",
        path: "id-credential-designer",
        permission: PERMISSION.TENANT_ADMIN_MENUS,
        buildUrl: getIdCredentialDesignerUrl,
      },
    ],
  },
  {
    title: "Fusesport Admin Panel",
    icon: "dribbble",
    path: "/tenant",
    usePath: false,
    permission: PERMISSION.FUSESPORT_ADMIN,
    submenu: [
      {
        title: "Tenant Management",
        path: ROUTES.TENANT,
        permission: PERMISSION.FUSESPORT_ADMIN,
      },
    ],
  },
];

function appendTermsAndPrivacyItems(previousNavItems, { termsPageLink, privacyPageLink }) {
  const result = [...previousNavItems];
  if (!isBlank(termsPageLink)) {
    result.push({
      title: "Terms",
      path: termsPageLink,
      requiresAuthentication: false,
    });
  }
  if (!isBlank(privacyPageLink)) {
    result.push({
      title: "Privacy",
      path: privacyPageLink,
      requiresAuthentication: false,
    });
  }
  return result;
}

export function getGlobalNavMenuNormal({ termsPageLink, privacyPageLink }) {
  return appendTermsAndPrivacyItems([], { termsPageLink, privacyPageLink });
}

export function getGlobalNavMenuElevated({ termsPageLink, privacyPageLink }) {
  return appendTermsAndPrivacyItems(GLOBAL_NAV_MENU_ELEVATED, { termsPageLink, privacyPageLink });
}
